import ActionComponent from './action'

export default [ ...ActionComponent ]

